<script setup lang="ts">
import { useMutation } from '@tanstack/vue-query'
import { useRouter } from 'vue-router'

import SkillForm, { type SkillFormValues } from '#content/components/SkillForm.vue'
import PageHeader from '#shared/components/PageHeader.vue'
import { contextHubClient } from '#shared/services/api/context-hub.client'

definePage({
  meta: { requiresAuth: true, title: 'New skill' },
})

const router = useRouter()

const createSkill = useMutation({
  mutationFn: async (values: SkillFormValues) => {
    const r = await contextHubClient.POST('/api/admin/skills', {
      body: {
        name: values.name,
        description: values.description,
        userFacingIntent: values.userFacingIntent,
        content: values.content,
        tags: values.tags,
        organizationScope: values.organizationScope,
        organizationIds: values.organizationScope === 'Restricted' ? values.organizationIds : [],
        runMode: values.runMode,
      },
    })
    return r.data
  },
  meta: { success: 'Skill created.', error: 'Failed to create skill.' },
})

async function handleSubmit(values: SkillFormValues) {
  await createSkill.mutateAsync(values)
  router.push('/skills')
}

function handleCancel() {
  router.push('/skills')
}
</script>

<template>
  <PageHeader title="New skill" />

  <SkillForm
    :submitting="createSkill.isPending.value"
    submit-label="Create"
    @submit="handleSubmit"
    @cancel="handleCancel"
  />
</template>
